exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._261Cf62KboQgZac0eakqd2 .ag-header-cell-text {\n  text-align: right;\n  flex: 1;\n}\n._261Cf62KboQgZac0eakqd2 div[col-id=\"SalesName\"] > div.ag-cell-label-container span.ag-header-cell-text {\n  text-align: left;\n}\n._261Cf62KboQgZac0eakqd2 div[col-id=\"FpvTradingNegoEntityRegion\"] > div.ag-cell-label-container span.ag-header-cell-text {\n  text-align: left;\n}\n", ""]);
// Exports
exports.locals = {
	"ag-grid-header": "_261Cf62KboQgZac0eakqd2"
};